// Props do react-select no visual do Jusfy DS (campo 40px, radius small,
// borda neutral-strong, foco brand, opção/chip brand-subtler).
const token = (name) => `var(--${name})`;

export const jdsSelectProps = {
  theme: (theme) => ({
    ...theme,
    borderRadius: 5,
    colors: {
      ...theme.colors,
      primary: token('border-brand-default'),
      primary25: token('bg-brand-subtler'),
      primary50: token('bg-brand-subtler'),
    },
  }),
  styles: {
    control: (base, { isFocused }) => ({
      ...base,
      minHeight: 40,
      borderColor: isFocused
        ? token('border-brand-default')
        : token('border-neutral-strong'),
      boxShadow: 'none',
      '&:hover': { borderColor: token('border-brand-default') },
    }),
    multiValue: (base) => ({
      ...base,
      background: token('bg-brand-subtler'),
      borderRadius: 999,
      paddingLeft: 4,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: token('fg-brand-stronger'),
      borderRadius: '999px 0 0 999px',
    }),
    multiValueRemove: (base) => ({
      ...base,
      borderRadius: '0 999px 999px 0',
      paddingRight: 6,
    }),
  },
};
